<template>
	<div>
		<v-radio-group v-model="editingitem.requiredfield" row dense label="Is dit veld verplicht?">
			<v-radio v-model="editingitem.fieldrequiredtrue" label="Nee" value="false"></v-radio>
			<v-radio v-model="editingitem.fieldrequiredfalse" label="Ja" value="true"></v-radio>
		</v-radio-group>

	</div>
</template>
<script>
export default {
	props: {
		editingitem: Object
	}
}
</script>
<style scoped>
</style>